<template>
  <div>
    <div class="modal fade" id="changePasswordJm" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true"
      data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
          <div class="modal-header2 p-0" style="">
            <h6 class="modal-title" id="exampleModalLabel">{{ translate('change_password') }}
              <button id="closeChangePassword" :style="skin.my_account.close_btn"
                style="background:transparent;color:white" type="button" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"><i class="fas fa-times"></i></button>
            </h6>
          </div>
          <div class="modal-body change-password-body">
            <div class="text-center change-password-content mt-3">
              <span v-if="showChangePassword">{{ translate('sugerencia') }}</span>
              <form class="change-password-form" @submit.prevent="changePassword()">
                <div class="pb-2 font-size-custom mb-3 my-3">
                  <div class="change-password-field">
                    <i class="fas change-password-reveal" :class="show1 ? 'fa-eye-slash' : 'fa-eye'"
                      @click="show_hide_Password('passwordJm')"></i>
                    <div class="change-password-input-wrap">
                      <input v-model="password" id="passwordJm" :type="show1 ? 'text' : 'password'" placeholder=" "
                        class="login-user-control" autocomplete="off" required>
                      <label class="change-password-label" for="passwordJm">{{ translate('new_password') }}</label>
                    </div>
                  </div>
                </div>
                <div class="pb-2 font-size-custom mb-3 my-3 change-password-field-spacing">
                  <div class="change-password-field">
                    <i class="fas change-password-reveal" :class="show2 ? 'fa-eye-slash' : 'fa-eye'"
                      @click="show_hide_Password('passwordJm2')"></i>
                    <div class="change-password-input-wrap">
                      <input v-model="password2" id="passwordJm2" :type="show2 ? 'text' : 'password'" placeholder=" "
                        class="login-user-control" maxlength="16" autocomplete="off" required>
                      <label class="change-password-label" for="passwordJm2">{{ translate('repeat_password') }}</label>
                    </div>
                  </div>
                </div>
                <div class="d-flex my-3 change-password-actions">
                  <button class="btn change-password-action-btn" type="button" data-bs-dismiss="modal"
                    aria-label="Close">CANCELAR</button>
                  <button id="submit_btn2" type="submit" class="btn change-password-action-btn"
                    :disabled="login_inProcess">ACEPTAR</button>
                </div>
              </form>
              <div v-if="status.message != ''" :class="'alert alert-' + status.type" role="alert">{{
                status.message }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "changePassword",
  props: ['skin', 'translation', 'language'],
  data() {
    return {
      password: "",
      password2: "",
      show1: false,
      show2: false,
      status: {
        message: "",
        type: ""
      },
      login_inProcess: false
    }
  },
  computed: {
    user() {
      let data = this.$store.getters['getUserData'];
      return data;
    },
    showChangePassword() {
      return this.$store.getters['getShowChangePassword'];
    },
    changedPass() {
      return this.$store.getters['getChangedPass'];
    },
    apiUrlnew() {
      return this.$store.getters['getApiUrlnew'];
    },
    site() {
      return this.$store.getters['getSite'];
    },
  },
  mounted() {
    const modalEl = document.getElementById('changePasswordJm');
    if (modalEl) {
      modalEl.addEventListener('shown.bs.modal', this.handleModalShown);
    }
  },
  watch: {
    changedPass(newVal) {
      if (newVal === false && this.user.token) {
        setTimeout(() => {
          document.getElementById('changePasswordBtn')?.click();
        }, 500);
      }
    }
  },
  beforeDestroy() {
    const modalEl = document.getElementById('changePasswordJm');
    if (modalEl) {
      modalEl.removeEventListener('shown.bs.modal', this.handleModalShown);
    }
  },
  methods: {
    handleModalShown() {
      const firstInput = document.getElementById('passwordJm');
      if (firstInput && typeof firstInput.focus === "function") {
        firstInput.focus();
      }
    },
    async changePassword() {
      try {
        this.login_inProcess = true;

        let data = await axios.post(this.apiUrlnew + "user/cambiar_password",
          {
            "users": [this.user.user_data.data.user_id ?? this.user.user_data.data.id],
            "password": this.password,
            "password1": this.password2,
            //"token":this.user.token,
            "login_id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
            //"site": this.site

          },
          {
            headers:
            {
              "x-player-token": this.user.token,
              "x-api-key": "FTBBW4bR1pKTUFsURbFD8RpcPygh8wN6"
            }
          }
        );
        if (data.data.error) {
          this.status.message = data.data.error;
          this.status.type = "danger";
        }
        else {
          this.status.message = data.data.message;
          this.status.type = "success";
          this.$store.commit("setChangedPass", false);
          this.logout();
          setTimeout(() => {
            document.getElementById("closeChangePassword").click();
          }, 2000)
        }
        this.login_inProcess = false;
      } catch (error) {
        this.status.message = error.response.data.error;
        this.status.type = "danger";
        this.login_inProcess = false;
      }

    },
    logout() {
      this.$store.dispatch('logOut');
      this.$root.$emit('forceRender');
    },
    translate(text) {
      if (text) {
        if (this.$props.translation[text]) {
          return this.$props.translation[text][this.$props.language];
        }
        else {
          var new_text_serched = text.replace(/ /g, "_");
          if (this.$props.translation[new_text_serched]) {
            return this.$props.translation[new_text_serched][this.$props.language];
          }
        }
        return text;
      }
    },
    show_hide_Password(target) {
      if (target == "passwordJm") {
        this.show1 = !this.show1;
      }
      else {
        this.show2 = !this.show2;
      }
    },
  }
}
</script>

<style scoped>
.modal-content {
  height: auto;
}

.modal-title {
  font-size: 16px;
  font-family: 'Metropolis', sans-serif !important;
  font-weight: 600;

}

.modal-header2 {
  margin-left: 5% !important;
  margin-right: 5% !important;
  margin-top: -1.25rem !important;
  margin-bottom: 0 !important;
  height: 60px;
  padding: 2rem !important;
  color: #fff;
  border-bottom: none;
  background: linear-gradient(40deg, #292d3d, #03040d) !important;
  display: flex;
  align-items: center;
}

.modal-title {
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  min-height: 100%;
  justify-content: space-between;
}

.modal-title .btn-close {
  margin-left: 16px;
  padding: 0;
  opacity: 1;
  color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}

.modal-title .btn-close i {
  color: #fff !important;
}

.modal-body {
  padding: 16px 32px 0px;
}

.change-password-body {
  min-height: 257px;
  display: flex;
  flex-direction: column;
}

.change-password-content {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.change-password-form {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.change-password-field-spacing {
  margin-top: 24px !important;
}

.change-password-actions {
  /* margin-top: auto !important;
    padding-bottom: 8px;
    justify-content: center; */
  margin-bottom: .25rem !important;
}

.change-password-action-btn {
  min-width: 102.86px;
  min-height: 46.3px;
  margin: 6px;
  padding: 13.44px 16px;
  border: 0;
  border-radius: 1px;
  background: #292D3D !important;
  color: #FFFFFF !important;
  font-family: "Metropolis", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12);

}


.change-password-action-btn:hover,
.change-password-action-btn:focus,
.change-password-action-btn:active {
  background: #292D3D !important;
  color: #FFFFFF !important;
  box-shadow: none;
}

.change-password-action-btn:disabled {
  opacity: 0.8;
}

.close2 {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5;
}

.login-user-control {
  color: #fff;
  width: 100%;
  -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #ced4da;
  -webkit-border-radius: 0;
  border-radius: 0;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  background-color: transparent;
  /* margin: 0 0 0.5rem; */
  -webkit-border-radius: 0;
  border-radius: 0;
  padding: 0.3rem 0 0.55rem;
  background-image: none;
  background-color: transparent;
  height: auto;
  font-size: 15px;
  line-height: 1.35;
  caret-color: #ffffff;
}

.change-password-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.change-password-input-wrap {
  position: relative;
  width: 100%;
}

.change-password-label {
  position: absolute;
  left: 0;
  top: 0.35rem;
  color: #666666;
  font-family: "Metropolis", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  pointer-events: none;
  transform-origin: left top;
  transition: top 0.2s ease, color 0.2s ease;
}

.login-user-control:focus+.change-password-label,
.login-user-control:not(:placeholder-shown)+.change-password-label {
  top: calc(-0.7rem - 4px);
  color: #ffffff;
}

.login-user-control:focus {
  border-bottom-color: #292D3D;
  box-shadow: 0 1px 0 0 #292D3D;
}

.change-password-reveal {
  color: #fff !important;
  font-size: 1.3rem !important;
  cursor: pointer;
  flex: 0 0 auto;
}
</style>
